import Vue from 'vue';
import Vuetify from 'vuetify';
import  './css/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
});
